import { Box } from "@mui/material"
import ButtonMedium4 from 'components/elements/ButtonMedium4';
import { Modal } from 'react-bootstrap';
import Headline5 from "./Headline5";

const ErrorModal = (props) => {
    const { show, onHide, children, headline } = props

    return (
        <Modal
          show={show}
          onHide={onHide}
          style={{ margin: "auto" }}
          centered
        >
          <Modal.Header
            className="border-0"
            closeButton
            style={{ fontSize: 9 }}
          >
            <Headline5>
                {headline}
            </Headline5>
          </Modal.Header>
          <Modal.Body className="pt-0">
            {children}
          </Modal.Body>
          <Modal.Footer>
            <Box
                display={'flex'}
                justifyContent={'flex-end'}
                gap={2}
            >
              <ButtonMedium4
                showIcon={false}
                translationKey="_OK_"
                fallbackText="Ok"
                onClick={onHide}
              />
            </Box>
          </Modal.Footer>
        </Modal>
    )
}

export default ErrorModal